<template>
  <div class="rich-text-editor">
    <UEditor
      ref="ueditor"
      v-model="editorValue"
      :height="height"
      base-url="/static/ueditor-plus/"
      :upload-url="uploadUrl"
      :upload-headers="uploadHeaders"
      :upload-data="uploadData"
      :upload-request="uploadRequest"
      :config="editorConfig"
      :multi-image-enabled="true"
    />
  </div>
</template>

<script>
import { UEditor } from 'vue2-ueditor-plus-editor'
import 'vue2-ueditor-plus-editor/dist/style.css'
import { getHeader } from '@/utils/header'

export default {
  name: 'RichTextEditor',
  components: {
    UEditor
  },
  model: {
    prop: 'content',
    event: 'input'
  },
  props: {
    content: {
      type: String,
      default: ''
    },
    height: {
      type: [Number, String],
      default: 360
    }
  },
  data() {
    return {
      editorValue: this.content || '',
      uploadUrl: '/callComponent/upload/uploadFile/uploadImage',
      uploadData: {
        communityId: '-1'
      },
      editorConfig: {
        zIndex: 3000,
        autoFloatEnabled: false,
        catchRemoteImageEnable: false,
        allowDivTransToP: false,
        toolbars: [[
          'fullscreen',
          'source',
          '|',
          'undo',
          'redo',
          '|',
          'bold',
          'italic',
          'underline',
          'strikethrough',
          'forecolor',
          'backcolor',
          '|',
          'insertorderedlist',
          'insertunorderedlist',
          'justifyleft',
          'justifycenter',
          'justifyright',
          'justifyjustify',
          '|',
          'link',
          'unlink',
          'simpleupload',
          'insertimage',
          'dialogimg',
          'insertvideo',
          'insertcode',
          'inserttable',
          '|',
          'removeformat',
          'preview'
        ]]
      }
    }
  },
  computed: {
    uploadHeaders() {
      return getHeader()
    }
  },
  watch: {
    content(value) {
      const nextValue = value || ''
      if (nextValue !== this.editorValue) {
        this.editorValue = nextValue
      }
    },
    editorValue(value) {
      this.$emit('input', value || '')
    }
  },
  methods: {
    async uploadRequest(type, file, progress, callbacks) {
      const callbackBag = callbacks || progress || {}
      const rawFile = file && (file.raw || file.file || file)
      if (!rawFile) {
        callbackBag.error && callbackBag.error('上传文件无效')
        return
      }
      const formData = new FormData()
      formData.append('uploadFile', rawFile)
      formData.append('communityId', '-1')
      formData.append('type', type)

      try {
        const response = await fetch(this.uploadUrl, {
          method: 'POST',
          headers: this.uploadHeaders,
          body: formData
        })
        const result = await response.json()
        const url = this.extractUploadUrl(result)
        if (!url) {
          callbackBag.error && callbackBag.error(result.msg || '上传失败')
          return
        }
        callbackBag.success && callbackBag.success({
          state: 'SUCCESS',
          url
        })
      } catch (error) {
        callbackBag.error && callbackBag.error(error.message || '上传失败')
      }
    },
    extractUploadUrl(result) {
      if (!result) {
        return ''
      }
      if (typeof result === 'string') {
        return result
      }
      return result.url ||
        result.src ||
        result.path ||
        (result.data && (result.data.url || result.data.src || result.data.path)) ||
        ''
    },
    clear() {
      this.editorValue = ''
    },
    setContent(html) {
      this.editorValue = html || ''
    },
    getContent() {
      return this.editorValue || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.rich-text-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
  line-height: normal;

  &:hover {
    border-color: #c0c4cc;
  }
}
</style>
